

import PropTypes from "prop-types";
import {Dropdown} from "primereact/dropdown";


export function DropSelect(props) {
    const handleChange = (event) => {
        props.setItem(event.target.value);

    };

    return (
            <Dropdown value={props.selectedItem} onChange={handleChange} options={props.selectList}
                      optionLabel="name" optionValue="name" disabled={props.disable} style={{fontSize: '1vw'}}
                      panelClassName=" flex-1 " tooltip="Select Instrument" variant="filled" className="flex  h-2rem align-items-center justify-content-center"  />
    )

}

DropSelect.propTypes = {
    selectList: PropTypes.array.isRequired,
    selectedItem: PropTypes.string.isRequired,
    setItem: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,


}
